import React from 'react';
import PropTypes from 'prop-types'

import FullStar from '../../images/full-star.svg'
import HalfStar from '../../images/half-star.svg'
import TotalReviews from '../../images/total-reviews.svg'
import TotalServices from '../../images/total-services.svg'

const RatingsDashboard = ({ totalServices, operatorDashboardRatings}) => (
  <React.Fragment>
    <div className="ratings-dashboard-wrapper">
      <div>
      {/*  <span className="db-card-title">Today's Sale</span>
        <span className="db-last-updated">Last Updated: {lastUpdated}</span> */}
      </div>
      <div className="row rb-card-wrap db-card-wrp db-border-bottom">
        <div className="col-xs-3">
          <div className="db-card">
            <p className="db-card-header"><img src={HalfStar} alt="Half Star" /> Average Rating</p>
            <div className="db-card-body">
              {operatorDashboardRatings.average_rating || 0}
            </div>
          </div>
        </div>
        <div className="col-xs-3">
          <div className="db-card">
            <p className="db-card-header"><img src={FullStar} alt="Full Star" /> Total Ratings</p>
            <div className="db-card-body">
              {operatorDashboardRatings.count|| 0}
            </div>
          </div>
        </div>
        <div className="col-xs-3">
          <div className="db-card">
            <p className="db-card-header"><img src={TotalReviews} alt="Total Reviews" /> Total Reviews</p>
            <div className="db-card-body">
              {operatorDashboardRatings.review_count || 0}
            </div>
          </div>
        </div>
        <div className="col-xs-3">
          <div className="db-card">
            <p className="db-card-header"><img src={TotalServices} alt="Total Services" /> Total Services</p>
            <div className="db-card-body">
              {totalServices || 0}
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
)

RatingsDashboard.propTypes = {
  operatorDashboardRatings: PropTypes.shape({
    average_rating: PropTypes.number,
    color_code: PropTypes.string,
    count: PropTypes.number,
    review_count: PropTypes.number,
  }),
};

export default RatingsDashboard;
